const ServiceMall = () => import('./ServiceMall.vue')

export {
  ServiceMall
}



// WEBPACK FOOTER //
// ./src/pages/servicemall/index.js